import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import { fetchMainSkins } from "../../../actions/mine_craft/mainSkinsActions";
import { queryParams } from "../../../helpers/UrlHelpers";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "../../../store/mine_craft/mainSkinsSlice";
import PageLayout from '../_partials/PageLayout';
import PageHeader from '../_partials/PageLayout/_PageHeader';
import List from "./_partials/_List";
import SidebarIndex from "./_partials/_SidebarIndex";
import EditCategory from "../categories/Edit";
import NewCategory from "../categories/New";
import ReorderCategories from "../categories/Reorder";
import New from "./New";
import Edit from "./Edit";
import './style.scss';
import Filter from "../../../componets/Filter";

const LIMIT = 42;
const TARGET_ID = 5;

const MainSkins: React.FC = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const categoryId      = queryParams.getInt(searchParams,'category_id');
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    dispatch(fetchCategories({ target_id: TARGET_ID }));
  }, [dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(fetchMainSkins(params))
  }, [searchParams, categoryId, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = {};

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-mainSkins-page'>
      <PageHeader
        title='Entities Skins'
        targetId={TARGET_ID}
        categoryId={categoryId}
        mainPage={{
          name: 'All',
          url: minecraftUrls.mainSkinsPath(),
          isActive: () => !categoryId
        }}
      />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Entity Skin
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Popular', key: 'popular_count' },
                { name: 'Comments', key: 'comments_count' },
                { name: 'Likes', key: 'likes_count' },
                { name: 'Downloads', key: 'downloads_count' },
              ]
            }}
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>

      <SidebarIndex categoryId={categoryId} />

      <New />
      <Edit />

      <NewCategory />
      <EditCategory />
      <ReorderCategories />
    </PageLayout>
  );
}

export default MainSkins;
